import { render, staticRenderFns } from "./UserBoardStepDetail.vue?vue&type=template&id=4b146be7&scoped=true&"
import script from "./UserBoardStepDetail.vue?vue&type=script&lang=js&"
export * from "./UserBoardStepDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserBoardStepDetail.vue?vue&type=style&index=0&id=4b146be7&lang=scss&scoped=true&"
import style1 from "./UserBoardStepDetail.vue?vue&type=style&index=1&id=4b146be7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b146be7",
  null
  
)

export default component.exports